/**
 * @param data {Data}
 */
function thenWaitForDomContentToLoad(data) {
	window.addEventListener("DOMContentLoaded", () => {
		whenDomContentLoaded(data);
	});
}